/**
 * Shared Zod schemas for the review-question shape used by both the
 * upstream node outputs and the `human_review`
 * node's `questions` config. Lifted out of the individual contract
 * files so a new question kind or field can't drift between the two.
 */

import { z } from "zod";

export const reviewQuestionOptionSchema = z.object({
  id: z.string().min(1),
  label: z.string().min(1),
  description: z.string().optional(),
  payload: z.record(z.string(), z.unknown()).optional(),
});

export const reviewQuestionSchema = z.object({
  id: z.string().min(1),
  kind: z.enum(["submission_match", "account_match", "product_match", "free_form"]),
  prompt: z.string().min(1),
  helperText: z.string().optional(),
  multiSelect: z.boolean(),
  options: z.array(reviewQuestionOptionSchema),
  allowCustomAnswer: z.boolean(),
  defaultSelectedOptionIds: z.array(z.string()).optional(),
});
